import { render, staticRenderFns } from "./shippingSettings.vue?vue&type=template&id=6957dbba"
import script from "./shippingSettings.vue?vue&type=script&lang=js"
export * from "./shippingSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports